import { useState } from 'react';

export interface InputValueProps {
    value: string;
    onChangeText: (newValue: string) => void;
    setValue: React.Dispatch<React.SetStateAction<string>>;
}

export default function useInputValue(initialValue?: string | undefined): InputValueProps {
    const [value, setValue] = useState(initialValue ?? '');
    const onChangeText = (newValue: string) => setValue(newValue);

    return {value, onChangeText, setValue};
}